import { HStack, Text } from "@reverb-ui/react";
import * as Icons from "@reverb-ui/icons-react";

export type THeaderCardProps = {
  title?: string;
  iconName?: string;
}

export const HeaderCard = ({title, iconName} : THeaderCardProps ) : JSX.Element => {
  // @ts-ignore
  const CardIcon = Icons[iconName];
  return (
    <HStack spacing={2} pb={2}>
      <CardIcon color="gray.500" size="sm" />
      <Text color="gray.500" textTransform="uppercase" fontSize="xs" fontWeight="semibold">
        {title}
      </Text>
    </HStack>
  );
};